import styled from "styled-components";
export const Wrapper = styled.div `
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  > div {
    z-index: 30;
  }
`;
export const StyledHeader = styled.div `
  height: 3.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 3.75rem;
    width: 100%;
    box-shadow: 0 0 12px 3px
      ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0.2)`};
    z-index: 33;
    pointer-events: none;
  }
`;
export const IconsWrapper = styled.div `
  display: flex;
  button {
    margin-right: 0.625rem;

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        width: 1.25rem;
        height: 1.25rem;
      }
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;
